
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor04 as ObiBipolar_transistor04Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-04.js';
 
 
 

 
 export const ObiBipolar_transistor04 = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-04',
   elementClass: ObiBipolar_transistor04Element,
   events: {
     
   }
  });
 
 